import Vue from "vue";
import Vuex from "vuex";
import hds from "@/store/modules/hds/index";
import hcs, {Account} from "@/store/modules/hcs/index";
import {ClientParamsType, GlobalParamsType} from "@/components/atoms/HcmSubscriber";

Vue.use(Vuex);

/**
 * スナックバー型
 */
interface SnackbarType {
  /** 表示する場合 true そうでない場合 false */
  visible: boolean;

  /** 色 */
  color?: string;

  /** 自動で消えるまでの時間 (ms) */
  timeout?: number | false;

  /** 読み込み中を表示するかどうか */
  loading?: boolean;

  /** メッセージ */
  message: string;
}

/**
 * ルートストアのステート型
 */
export interface RootStateType {
  /** スナックバー */
  snackbar: SnackbarType;

  /** グローバルパラメータ */
  globalParams: GlobalParamsType;

  /** クライアントパラメータ */
  clientParams: ClientParamsType;
}

/**
 * ルートストア
 */
export default new Vuex.Store<RootStateType>({
  state: {
    snackbar: {
      visible: false,
      message: '',
    },
    globalParams: {
      notification: '',
      maintenance: '',
      status: 'open'
    },
    clientParams: {
      revision: ''
    }
  },
  getters: {
    /**
     * アカウントを取得します
     * hcs/account へのエイリアスです
     */
    account(_, getters): Partial<Account> {
      return getters['hcs/account'] as Partial<Account>;
    }
  },
  mutations: {
    /**
     * スナックバーを表示する
     */
    showSnackbar(state, payload: Omit<SnackbarType, 'visible'>) {
      state.snackbar.visible = false;
      switch(payload.color) {
        case 'warn':
          payload.color = 'orange darken-1';
          break;
        case 'fail':
        case 'failed':
          payload.color = 'red darken-1';
          break;
      }
      setTimeout(() => {
        state.snackbar.visible = true;
        state.snackbar.message = payload.message;
        state.snackbar.color = payload.color;
        state.snackbar.timeout = payload.timeout === false ? 0 : (payload.timeout || 10000);
        state.snackbar.loading = payload.loading || false;
      }, 0);
    },
    /**
     * スナックバーを非表示にする
     */
    hideSnackbar(state) {
      state.snackbar.visible = false;
    },
    /**
     * GlobalParams を更新します
     */
    updateGlobalParams(state, {payload}: {payload: GlobalParamsType}) {
      state.globalParams = {...payload};
    },
    /**
     * ClientParams を更新します
     */
    updateClientParams(state, {payload}: {payload: ClientParamsType}) {
      state.clientParams = {...payload};
    }
  },
  actions: {
  },
  modules: {
    hds, hcs
  }
});
